<template>
    <div>
      <!--添加内容信息-->
      <div class="logindiv" id="AddForm_download">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              添加下载内容
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddForm" :rules="rules" ref="AddForm" style="margin-top: 50px;">
              <el-form-item prop="title">
                <el-input type="text" v-model="AddForm.title" placeholder="标题"></el-input>
              </el-form-item>
              <el-form-item prop="content">
                <el-upload
                  class="upload-demo"
                  ref="upload_music"
                  action="/api/AddDownload"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess"
                  :auto-upload="false"
                  :data="AddForm"
                  :headers="myHeaders"
                  :limit="1">
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" @click="AddLabel">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item>
                <el-button type="primary" class="btn" @click="Addwindow()"><i class="el-icon-circle-plus-outline"></i>添加新内容</el-button>
              </el-form-item>
              <el-form-item label="标题">
                <el-input v-model="formInline.title" placeholder="标题" class="elInput"></el-input>
              </el-form-item>
              <el-form-item label="起始日期">
                <el-date-picker v-model="formInline.statetime" type="datetime" value-format="timestamp" placeholder="起始日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期">
                <el-date-picker v-model="formInline.endtime" type="datetime" value-format="timestamp" placeholder="结束日期"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="150"></el-table-column>
              <el-table-column align="center" label="发布人" prop="admin_name" width="300"></el-table-column>
              <el-table-column align="center" label="标题" prop="title"></el-table-column>
              <el-table-column align="center" label="发布时间" prop="time" width="300">
                <template slot-scope="scope">
                  <span>{{scope.row.time*1 | formatDate}}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="300">
                <template slot-scope="scope">
                  <span>
                    <el-button size="small" @click="downloadF(scope.row)">下载</el-button>
                  </span>
                  <span>
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="这是一段内容确定删除吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  let Atoken=sessionStorage.getItem("Atoken")
  export default {
    data() {
      var title = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入标题'))
        } else {
          callback()
        }
      }
      return {
        myHeaders: {
          Atoken:Atoken,
        },
        data:'',
        tableData: [],
        loading: false,
        formInline: {
          statetime:'',
          title:'',
          endtime:'',
          type:'0',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          admin_id:'',
          title:'',
          content:'',
          message_id:''
        },
        rules: {
          title: [{
            required: true,
            trigger: 'blur',
            validator: title
          }]
        },
        //回调数据
        returnes:{
          returns:'',
        },
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          }
        },

    created() {
      //this.getData();
    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
    },
    methods: {
      //进行判定
      chark(){
        this.$emit("parentHandle", 2)
      },
      //文件下载
      downloadF(item){
        const link = document.createElement('a')
        let name=item.title;
              link.setAttribute("download", name) //下载的文件名
              link.href = "/api"+item.content_url   //文件url
              link.click()
      },
      //文件的上传
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleAvatarSuccess(res, file) {
        let data = res;
        if(data.info.code=='1000'){
          this.handleAvatarSuccess_sql(data.data);
        }
      },
      //上传成功进行回调
      handleAvatarSuccess_sql(datas){
        this.returnes.returns=datas
        commonAPI('AddDownload_sql',this.returnes).then(res => {
          let data=res.data;
          if(this.response.response(data)){
            this.AddForm.title='';
            this.getData();
            this.close();
          }
        })
      },
      //重置查询
      resetting() {
        this.formInline.title = '';
        this.formInline.statetime = '';
        this.formInline.endtime = '';
        this.getData();
      },
      //添加内容
      AddLabel(){
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          this.AddForm.admin_id=this.$store.state.a_id;
          this.$refs.upload_music.submit();
        }else{
          return false;
        }
        })
      },
      Addwindow(row){
        //this.AddForm.message_id=row.id;
        document.getElementById('AddForm_download').style.display='block';
        document.getElementById('zhedang').style.display='block';
        //console.log('打开窗口');
      },
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteDownload',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //查询
      getData() {
        this.loading = true,
        commonAPI('queryDownloadlist',this.formInline).then(res => {
          this.loading = false;
          this.tableData = res.data.data.rows;
          this.pageTotal=res.data.data.total;
          //console.log(res.data.rows);
        })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      close(){
        this.AddForm.title='';
        document.getElementById('AddForm_download').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 25%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/system/Download.vue